import { ReactNode } from 'react';

import { setHideResumeDatabaseAd } from 'modules/main/store/ducks/layout';
import { updateApplicantProfile } from 'modules/main/store/ducks/userEnvironment';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { dismissResumeDBLoggedOut } from 'utils/resumeDatabase';

// eslint-disable-next-line react/function-component-definition
const ResumeDatabaseResponseContainer = ({
  children,
}: {
  children: (arg0: { dismiss: () => void }) => ReactNode;
}) => {
  const { user } = useUserEnvironment();
  const dispatch = useMainDispatch();

  const dismiss = () => {
    if (user) {
      dispatch(
        updateApplicantProfile({
          isRecruitable: false,
        }),
      );
    } else {
      dismissResumeDBLoggedOut();
    }
    dispatch(setHideResumeDatabaseAd(true));
  };

  return <>{children({ dismiss })}</>;
};

// eslint-disable-next-line import/no-default-export
export default ResumeDatabaseResponseContainer;
